import { memo, useEffect } from "react";
import DOMPurify from "dompurify";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const BoxWrapperstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "5px solid #6edbff",
  p: "30px 35px 34px",
  borderRadius: "15px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& h2": { fontSize: "18px", fontWeight: "100", mb: "10px" },
  "& p": { fontSize: "16px", mb: "18px", color: "#797979" },
  "& button": {
    boxShadow: "none",
    textTransform: "none",
    backgroundColor: "#ff642d",
    color: "#fff",
    borderRadius: "7px",
    border: "1px solid #ff642d",
    padding: "6px 24px 6px",
    width: "100%",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
      color: "#ff642d",
    },
  },
};

function ResetVerificationPopup({ message, open, setOpen, handleCloseAuth }) {
  const handleClose = () => setOpen(false);

  const handleClosebtn = () => {
    setOpen(false);
    window.close(); // Close the browser tab
  };

  // Listen for the "Enter" key press
  useEffect(() => {
    const handleKeyPress = event => {
      if (event.key === "Enter") {
        handleClosebtn();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleCloseAuth ? false : handleClose}
      closeAfterTransition
      slots={{
        backdrop: Backdrop,
      }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={BoxWrapperstyle}>
          <Typography component="p" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message || "") }} />
          {message && (
            <Button variant="contained" className="okButton" onClick={handleClosebtn}>
              Ok
            </Button>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}

export default memo(ResetVerificationPopup);
